/**
 * Qatar Pearl Diving - PDF Presentation Configuration
 *
 * Slide-by-slide configuration with:
 * - Page numbers
 * - Pre-scripted narrations for avatar TTS
 */

export const qatarPearlDivingPresentation = {
  pdfUrl: 'https://storage.googleapis.com/qudemo-test-qudemo/qatar_pearl.pdf',

  slides: [
    {
      page: 1,
      title: 'Pearl Diving Heritage',
      narration: `This image shows the pearl diving heritage of Qatar.   For generations, pearl diving was the lifeblood of Qatar's economy.   Divers would spend months at sea, diving repeatedly to collect these precious gems from the Gulf.`,
    },
  ],
};

export default qatarPearlDivingPresentation;
